import { render, staticRenderFns } from "./StandardsImportCSVModal.vue?vue&type=template&id=7012f4a8&"
import script from "./StandardsImportCSVModal.vue?vue&type=script&lang=js&"
export * from "./StandardsImportCSVModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports